import React from 'react';
import classNames from 'classnames';

function makeListComponent(listType) {
  return function (_ref) {
    var children = _ref.children,
        _ref$className = _ref.className,
        className = _ref$className === void 0 ? "jkl-body" : _ref$className;
    var componentClassName = classNames("jkl-list", className, {
      "jkl-list--ordered": listType === "ordered"
    });
    var C = listType === "ordered" ? "ol" : "ul";
    return /*#__PURE__*/React.createElement(C, {
      "data-testid": "jkl-list",
      className: componentClassName
    }, children);
  };
}

var UnorderedList = makeListComponent("unordered");
var OrderedList = makeListComponent("ordered");
var List = UnorderedList;

function makeListItem(listItemType) {
  var ListItem = function ListItem(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === void 0 ? "" : _ref$className,
        children = _ref.children;
    return /*#__PURE__*/React.createElement("li", {
      className: classNames("jkl-list__item", className, {
        "jkl-list__item--iconed": listItemType !== "normal",
        "jkl-list__item--check": listItemType === "check",
        "jkl-list__item--cross": listItemType === "cross"
      }),
      "data-testid": "jkl-list-item"
    }, children);
  };

  return ListItem;
}

var ListItem = makeListItem("normal");
var CrossListItem = makeListItem("cross");
var CheckListItem = makeListItem("check");

export { CheckListItem, CrossListItem, List, ListItem, OrderedList, UnorderedList };
